import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=7fa8c9ff&scoped=true&"
import script from "./ProfileAvatar.vue?vue&type=script&lang=ts&"
export * from "./ProfileAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa8c9ff",
  null
  
)

export default component.exports